export const DURATION_LABELS: Record<string, string> = {
  less_than_1_year: 'Less than 1 year',
  '1_3_years': '1-3 years',
  '4_7_years': '4-7 years',
  '8_plus_years': '8+ years',
  all_my_life: 'All my life',
};

// City variant adds emoji decoration for the preview card.
export const CITY_DURATION_LABELS: Record<string, {label: string; emoji: string}> = {
  less_than_1_year: {label: 'Less than 1 year', emoji: '🚀'},
  '1_3_years': {label: '1-3 years', emoji: '🌟'},
  '4_7_years': {label: '4-7 years', emoji: '🍊'},
  '8_plus_years': {label: '8+ years', emoji: '🌴'},
  all_my_life: {label: 'All my life', emoji: '🎉'},
};

export const formatDuration = (key: string | null | undefined): string =>
  key ? DURATION_LABELS[key] || key : '';
